<template>
  <div
    class="content-box"
    :class="{ 'edit-mode': inEditMode }"
  >
    <div class="d-flex flex-lg-row flex-column justify-space-between mb-3 align-items-start">
      <div class="d-flex align-items-start mb-2">
        <div
          v-if="horse.catalogue_number && isHorseQualifiedForFinal"
          class="cat-number"
        >
          {{ horse.catalogue_number }}
        </div>

        <div>
          <h3 class="mb-0">
            <span v-if="horse.horse_name">
              {{ horse.horse_name }} |
            </span>
            {{ horse.life_id_prefix }} {{ horse.life_id }}

            <span
              class="tag-status d-lg-inline-flex"
              :class="[statusColor]"
            >
              {{
                'javascript.horse_registration.' + (horse.is_draft ? 'draft' : currentEvent.pivot.registration_status) | lowercase | snakecase | trans
              }}
            </span>

            <br>

            <small class="font-weight-lighter">
              {{ 'javascript.horse_registration.by' | trans }}
              {{ foalV_MV_MMV }}
            </small>
          </h3>
        </div>
      </div>

      <div>
        <h5 class="gray-box d-inline-block">
          {{ dateOfBirth }} |
          <span v-if="isFoal">
            {{ `javascript.horse_registration.${horse.sex}` | lowercase | trans }} |
          </span>
          {{ `javascript.horse_registration.${horse.type}` | lowercase | trans }} |
          {{ `javascript.horse_registration.${horse.discipline}` | lowercase | trans }}
        </h5>

        <p class="font-weight-normal mb-0">
          {{ 'javascript.horse_registration.sent' | trans }}: <span
          class="text-uppercase">{{ updatedAtDate + ' ' + updatedAtTime }}</span>
        </p>
      </div>

      <div class="d-flex gap-xs align-items-center">
        <!-- <div
          v-if="canBeEdited"
          class="edit-toggle"
          @click="toggleEdit"
        >
          <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_899_4554)">
              <path
                d="M2.625 18.9688H13.875C14.5723 18.9668 15.2403 18.6882 15.7324 18.1943C16.2245 17.7003 16.5006 17.0313 16.5 16.334V10.6812C16.5 10.4823 16.421 10.2916 16.2803 10.1509C16.1397 10.0103 15.9489 9.93125 15.75 9.93125C15.5511 9.93125 15.3603 10.0103 15.2197 10.1509C15.079 10.2916 15 10.4823 15 10.6812V16.334C15.001 16.6336 14.8831 16.9213 14.6722 17.134C14.4613 17.3468 14.1746 17.4672 13.875 17.4688H2.625C2.32543 17.4672 2.03873 17.3468 1.82781 17.134C1.6169 16.9213 1.499 16.6336 1.5 16.334V5.1035C1.499 4.80393 1.6169 4.5162 1.82781 4.30345C2.03873 4.09071 2.32543 3.97034 2.625 3.96875H8.25C8.44891 3.96875 8.63968 3.88973 8.78033 3.74908C8.92098 3.60843 9 3.41766 9 3.21875C9 3.01984 8.92098 2.82907 8.78033 2.68842C8.63968 2.54777 8.44891 2.46875 8.25 2.46875H2.625C1.92773 2.47074 1.25973 2.74927 0.767594 3.24323C0.275461 3.7372 -0.000597818 4.40623 9.72081e-07 5.1035V16.334C-0.000597818 17.0313 0.275461 17.7003 0.767594 18.1943C1.25973 18.6882 1.92773 18.9668 2.625 18.9688Z"
                fill="#CD6215"/>
              <path
                d="M7.09136 8.87646L6.49961 11.587C6.47283 11.7099 6.4774 11.8376 6.51292 11.9583C6.54844 12.079 6.61376 12.1889 6.70286 12.2777C6.79319 12.3643 6.90307 12.4279 7.02318 12.463C7.14329 12.4981 7.2701 12.5038 7.39286 12.4795L10.0974 11.8862C10.2378 11.8554 10.3664 11.7848 10.4679 11.683L17.3034 4.84746C17.5123 4.63852 17.6781 4.39046 17.7912 4.11746C17.9043 3.84445 17.9625 3.55184 17.9625 3.25633C17.9625 2.96082 17.9043 2.66821 17.7912 2.3952C17.6781 2.1222 17.5123 1.87414 17.3034 1.66521C16.8749 1.25581 16.3052 1.02734 15.7126 1.02734C15.12 1.02734 14.5503 1.25581 14.1219 1.66521L7.29686 8.50746C7.19443 8.60823 7.1231 8.73631 7.09136 8.87646ZM15.1824 2.72646C15.325 2.58976 15.515 2.51345 15.7126 2.51345C15.9102 2.51345 16.1002 2.58976 16.2429 2.72646C16.3816 2.86793 16.4593 3.05818 16.4593 3.25633C16.4593 3.45448 16.3816 3.64473 16.2429 3.78621L15.7126 4.31646L14.6521 3.25596L15.1824 2.72646ZM8.50736 9.41196L13.5879 4.31871L14.6379 5.37396L9.55511 10.4687L8.20886 10.7642L8.50736 9.41196Z"
                fill="#CD6215"/>
            </g>
            <defs>
              <clipPath id="clip0_899_4554">
                <rect width="18" height="18" fill="white" transform="translate(0 0.96875)"/>
              </clipPath>
            </defs>
          </svg>
        </div> -->

        <div class="deleteHorse">
          <form
            :action="`/en/account/foals-mares-registrations/${horse.id}/delete`"
            :id="'delete-' + horse.id"
            method="POST"
          >
            <input type="hidden" name="_method" value="DELETE"/>
            <input type="hidden" name="_token" :value="token"/>

            <div
              v-if="horse.is_draft"
              :style="{ color: '#CD6215', cursor: 'pointer' }"
              @click="deleteRegistration"
            >
              <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1359_6066)">
                  <path
                    d="M14.458 6.21535L14.1429 15.7215C14.1161 16.5357 13.7721 17.3074 13.1839 17.8728C12.5957 18.4382 11.8096 18.7529 10.9925 18.75H5.00669C4.19012 18.7529 3.40451 18.4387 2.81639 17.8739C2.22828 17.3092 1.8839 16.5383 1.85626 15.7247L1.54122 6.21535C1.53432 6.00711 1.61069 5.80466 1.75352 5.65255C1.89636 5.50044 2.09395 5.41113 2.30284 5.40426C2.51172 5.39739 2.71479 5.47352 2.86737 5.61591C3.01995 5.7583 3.10954 5.95528 3.11643 6.16353L3.43148 15.6721C3.44717 16.078 3.62003 16.4621 3.91375 16.7436C4.20748 17.0252 4.59922 17.1823 5.00669 17.182H10.9925C11.4005 17.1822 11.7927 17.0247 12.0865 16.7425C12.3803 16.4603 12.5528 16.0754 12.5677 15.6689L12.8828 6.16353C12.8897 5.95528 12.9793 5.7583 13.1318 5.61591C13.2844 5.47352 13.4875 5.39739 13.6964 5.40426C13.9053 5.41113 14.1029 5.50044 14.2457 5.65255C14.3885 5.80466 14.4649 6.00711 14.458 6.21535ZM15.5 3.05185C15.5 3.2601 15.417 3.45981 15.2693 3.60706C15.1216 3.75431 14.9213 3.83704 14.7124 3.83704H1.28761C1.07872 3.83704 0.87839 3.75431 0.730685 3.60706C0.58298 3.45981 0.5 3.2601 0.5 3.05185C0.5 2.84361 0.58298 2.6439 0.730685 2.49665C0.87839 2.3494 1.07872 2.26667 1.28761 2.26667H3.72919C3.97875 2.26734 4.21962 2.17543 4.40495 2.00882C4.59027 1.84221 4.70679 1.61281 4.73182 1.36529C4.78994 0.784633 5.06282 0.246348 5.49729 -0.14469C5.93176 -0.535729 6.4967 -0.75151 7.08204 -0.749992H8.91717C9.50251 -0.75151 10.0674 -0.535729 10.5019 -0.14469C10.9364 0.246348 11.2093 0.784633 11.2674 1.36529C11.2924 1.61281 11.4089 1.84221 11.5943 2.00882C11.7796 2.17543 12.0205 2.26734 12.27 2.26667H14.7116C14.9205 2.26667 15.1208 2.3494 15.2685 2.49665C15.4162 2.6439 15.4992 2.84361 15.4992 3.05185H15.5ZM6.09911 2.26667H9.90168C9.79818 2.03092 9.73049 1.78111 9.70084 1.52546C9.68133 1.33192 9.59045 1.15249 9.44581 1.02193C9.30117 0.891379 9.11307 0.818992 8.91796 0.8188H7.08283C6.88771 0.818992 6.69961 0.891379 6.55498 1.02193C6.41034 1.15249 6.31946 1.33192 6.29995 1.52546C6.27004 1.78115 6.20288 2.03096 6.09911 2.26667ZM6.89223 14.163V7.47714C6.89223 7.26889 6.80925 7.06918 6.66154 6.92193C6.51384 6.77468 6.31351 6.69195 6.10462 6.69195C5.89573 6.69195 5.6954 6.77468 5.5477 6.92193C5.39999 7.06918 5.31701 7.26889 5.31701 7.47714V14.1661C5.31701 14.3743 5.39999 14.5741 5.5477 14.7213C5.6954 14.8686 5.89573 14.9513 6.10462 14.9513C6.31351 14.9513 6.51384 14.8686 6.66154 14.7213C6.80925 14.5741 6.89223 14.3743 6.89223 14.1661V14.163ZM10.6838 14.163V7.47714C10.6838 7.26889 10.6008 7.06918 10.4531 6.92193C10.3054 6.77468 10.1051 6.69195 9.89617 6.69195C9.68728 6.69195 9.48695 6.77468 9.33924 6.92193C9.19154 7.06918 9.10856 7.26889 9.10856 7.47714V14.1661C9.10856 14.3743 9.19154 14.5741 9.33924 14.7213C9.48695 14.8686 9.68728 14.9513 9.89617 14.9513C10.1051 14.9513 10.3054 14.8686 10.4531 14.7213C10.6008 14.5741 10.6838 14.3743 10.6838 14.1661V14.163Z"
                    fill="#CD6215"/>
                </g>
                <defs>
                  <clipPath id="clip0_1359_6066">
                    <rect width="15" height="18" fill="white" transform="translate(0.5)"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="d-sm-flex flex-grow-1 w-100 pt-3 border-top">
      <div class="card border-0 flex-grow-1 mb-sm-0 mb-3">
        <div class="d-flex flex-column">
          <div style="min-width:75px">
            <h4>
              {{ 'javascript.horse_registration.owner' | trans }}
            </h4>
          </div>
          <div class="">
            <h5 class="font-weight-normal">
              {{ foalBreederOwner.owner.fullname }}
            </h5>
            <h5 class="font-weight-normal">
              {{ foalBreederOwner.owner.zip }} {{ foalBreederOwner.owner.city }}
            </h5>
          </div>
        </div>
      </div>

      <div class="card border-0 flex-grow-1">
        <div class="d-flex flex-column">
          <div style="min-width:75px">
            <h4>
              {{ 'javascript.horse_registration.breeder' | trans }}
            </h4>
          </div>
          <div class="">
            <h5 class="font-weight-normal">
              {{ foalBreederOwner.breeder.fullname }}
            </h5>
            <h5 class="font-weight-normal">
              {{ foalBreederOwner.breeder.zip }} {{ foalBreederOwner.breeder.city }}
            </h5>
          </div>
        </div>
      </div>

      <template v-if="isFoal">
        <div class="flex-grow-1">
          <h4>
            <strong>
              {{ 'javascript.horse_registration.qualified_foal_event' | trans }}
            </strong>
          </h4>
          <p class="mb-0">
            {{ currentEvent ? currentEvent.translated_name : '' }}
          </p>
        </div>
      </template>
    </div>

    <div class="info-panel">
      <!--
      <div class="card p-3 pb-0 mt-2 bg-light c-capitalize border-0">
        <template v-if="horse.horse_type !== 'Mare'">
          <h5> {{ 'javascript.horse_registration.event' | trans }}</h5>
          <h5 class="font-weight-normal border-bottom pb-3"> {{ currentEvent ? currentEvent.translated_name : '' }}</h5>
        </template>
        <template v-else>
          <h5> {{ 'javascript.horse_registration.mare_championship' | trans }}</h5>
        </template>
        <div class="d-flex flex-wrap mt-2">
          <div class="foal-info-table-cell">
            <h5>{{ 'javascript.horse_registration.category' | trans }}</h5>
            <h5 class="font-weight-normal mb-0"> {{ 'javascript.horse_registration.' + horse.horse_type | lowercase | trans }} </h5>
          </div>
          <div class="foal-info-table-cell">
            <h5>{{ 'javascript.horse_registration.type' | trans }}</h5>
            <h5 class="font-weight-normal mb-0"> {{ 'javascript.horse_registration.' + horse.type | lowercase | trans }} </h5>
          </div>
          <div class="foal-info-table-cell">
            <h5>{{ 'javascript.horse_registration.discipline' | trans }}</h5>
            <h5 class="font-weight-normal mb-0"> {{ 'javascript.horse_registration.' + horse.discipline | lowercase | trans }} </h5>
          </div>
          <div class="foal-info-table-cell">
            <h5>{{ 'javascript.horse_registration.sex' | trans }}</h5>
            <h5 class="font-weight-normal mb-0"> {{ 'javascript.horse_registration.' + (horse.horse_type === 'Mare' ? 'Mare' : horse.sex) | lowercase | trans }} </h5>
          </div>
        </div>
      </div>
    -->

      <div class="form-row d-flex border-0 mt-0 border-top ">
        <div
          class="col-12"
          data-role="accordion"
          data-one-frame="false"
          data-show-active="true"
          data-on-frame-open="console.log('frame was opened!', arguments[0])"
          data-on-frame-close="console.log('frame was closed!', arguments[0])"
        >
          <div
            class="frame"
            :class="{ 'active': isMore }"
          >
            <div class="content">
              <!--<div class="d-flex bg-light pb-3 p-3 border-top flex-wrap">
                <div class="foal-info-table-cell">
                  <h5>{{ 'javascript.horse_registration.life_id' | trans }}</h5>
                  <h5 class="font-weight-normal mb-0"> {{ horse.life_id_prefix }}{{ horse.life_id }} </h5>
                </div>
                <div class="foal-info-table-cell">
                  <h5>{{ 'javascript.horse_registration.color' | trans }}</h5>
                  <h5 class="font-weight-normal mb-0"> {{
                      horse.lot_color ? horse.lot_color.translated_long_name : ''
                    }} </h5>
                </div>
                <div class="foal-info-table-cell">
                  <h5>{{ 'javascript.horse_registration.date_of_birth' | trans }}</h5>
                  <h5 class="font-weight-normal mb-0"> {{ dateOfBirth }} </h5>
                </div>
              </div>
              <div class="d-flex bg-light pb-3 p-3 border-top flex-wrap">
                <div class="foal-info-table-cell">
                  <h5>{{ 'javascript.horse_registration.sale_status' | trans }}</h5>
                  <h5 class="font-weight-normal mb-0"> {{ 'javascript.horse_registration.' + horse.sale_status | lowercase | snakecase | trans }} </h5>
                </div>
                <div class="foal-info-table-cell">
                  <h5>{{ 'javascript.horse_registration.breed_association' | trans }}</h5>
                  <h5 class="font-weight-normal mb-0"> {{
                      horse.lot_breed ? horse.lot_breed.translated_long_name : ''
                    }} </h5>
                </div>
              </div>-->

              <section class="mt-0">
                <div
                  id="pedigree-view"
                  class="lot-detail content-box px-0"
                >
                  <pedigree-view
                    ref="horse-pedigree"
                    :pedigrees="horse.pedigree"
                    show-horse-link
                  ></pedigree-view>
                </div>
              </section>

              <qualified-foal-score
                v-if="isFoal"
                :foal="horse"
                :current-event="currentEvent"
                :locale="locale"
              ></qualified-foal-score>
            </div>

            <div class="frame-footer mt-4 bg-unset">
              <a
                class="readMore"
                href="#"
                @click.prevent="showMoreOrLess"
              >
                <span v-if="!isMore">{{ 'javascript.horse_registration.show_more' | trans }}</span>
                <span v-else>{{ 'javascript.horse_registration.show_less' | trans }}</span>
                <i class="show-more-icon fa fa-chevron-down"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="edit-panel">
      <FoalRegistration
        :horse='horse'
        :events='events'
        :event-id='currentEvent ? currentEvent.id : null'
        :lot-breeds='lotBreeds'
        :lot-colors='lotColors'
        :sale-statuses='saleStatuses'
        :mare-primes="marePrimes"
        @discard="toggleEdit"
        :locale="locale"
      ></FoalRegistration>
    </div>
  </div>
</template>

<script>
import FoalRegistration from './FoalRegistration.vue'
import PedigreeView from '../Pedigree/Index.vue'
import QualifiedFoalScore from '../Championship/QualifiedFoalScore.vue'

export default {
  name: 'HorseCard',

  components: {
    FoalRegistration,
    PedigreeView,
    QualifiedFoalScore,
  },

  props: {
    horse: {
      type: Array | Object
    },

    events: {
      type: Array | Object
    },

    lotColors: {
      type: Array | Object
    },

    lotBreeds: {
      type: Array | Object
    },

    saleStatuses: {
      type: Array | Object
    },

    currentEvent: {
      type: Array | Object
    },

    eventId: {
      type: Number
    },

    locale: {
      type: String,
      default: 'en',
    },

    marePrimes: {
      type: Array | Object,
      default() {
        return null
      }
    }
  },

  data() {
    return {
      inEditMode: false,
      isMore: false,
      token: ''
    }
  },

  created() {
    this.token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  },

  computed: {
    isMare() {
      return this.horse.horse_type === 'Mare'
    },

    isFoal() {
      return this.horse.horse_type === 'Foal'
    },

    statusColor() {
      if (this.horse.is_draft) {
        return 'status-draft'
      } else {
        switch (this.currentEvent.pivot.registration_status) {
          case 'Sent':
            return 'status-pending'
          case 'Qualified for the final':
          case 'Participating in the final':
            return 'status-success'
          case 'Not qualified for the final':
          case 'Failure to attend':
            return 'status-red'
        }
      }
    },

    dateOfBirth() {
      return moment
        .utc(this.horse.date_of_birth)
        .locale(this.locale)
        //.format('LL')
        .format('DD.MM.YYYY')
    },

    updatedAtDate() {
      return moment
        .utc(this.horse.updated_at)
        .locale(this.locale)
        .format('LL')
    },

    updatedAtTime() {
      return moment
        .utc(this.horse.updated_at)
        .local()
        .format('HH:mm')
    },

    isHorseQualifiedForFinal() {
      return this.currentEvent.pivot.registration_status === 'Qualified for the final'
    },

    foalOwnerTitle() {
      return this.foalBreederOwner.owner && this.foalBreederOwner.owner.title
        ? this.$options.filters.trans(`javascript.horse_registration.${this.foalBreederOwner.owner.title.toLowerCase()}`)
        : ''
    },

    foalBreederTitle() {
      return this.foalBreederOwner.breeder && this.foalBreederOwner.breeder.title
        ? this.$options.filters.trans(`javascript.horse_registration.${this.foalBreederOwner.breeder.title.toLowerCase()}`)
        : ''
    },

    foalV() {
      return this.horse.pedigree.V
        ? this.horse.pedigree.V.name
        : ''
    },

    foalMV() {
      return this.horse.pedigree.MV
        ? this.horse.pedigree.MV.name
        : ''
    },

    foalMMV() {
      return this.horse.pedigree.MMV
        ? this.horse.pedigree.MMV.name
        : ''
    },

    foalV_MV_MMV() {
      let parts = []

      if (this.foalV) parts.push(this.foalV)
      if (this.foalMV) parts.push(this.foalMV)
      if (this.foalMMV) parts.push(this.foalMMV)

      return parts.join(' | ')
    },

    organizationTitles() {
      return ['Company', 'Breeder community']
    },

    canBeEdited() {
      return this.currentEvent.pivot.registration_status === 'Sent'
    },

    foalBreederOwner() {
      let breeder, owner
      const registeredAs = this.horse.registered_as

      if (registeredAs === 'owner and breeder') {
        breeder = this.horse.user
        owner = this.horse.user
      } else if (registeredAs === 'not owner and not breeder') {
        breeder = this.horse.breeder
        owner = this.horse.owner
      } else if (registeredAs === 'owner') {
        breeder = this.horse.breeder
        owner = this.horse.user
      } else if (registeredAs === 'breeder') {
        breeder = this.horse.user
        owner = this.horse.owner
      }

      return {
        breeder,
        owner
      }
    }
  },

  methods: {
    toggleEdit() {
      this.inEditMode = !this.inEditMode
    },

    showMoreOrLess() {
      this.isMore = !this.isMore
    },

    deleteRegistration() {
      const horseId = this.horse.id
      const form = document.querySelector('#delete-' + horseId)

      Metro.dialog.create({
        title: this.$options.filters.trans('javascript.horse_registration.deletion_confirmation'),
        content: '<div>' + this.$options.filters.trans('javascript.horse_registration.deletion_text') + '</div>',
        actions: [
          {
            caption: this.$options.filters.trans('javascript.horse_registration.yes'),
            cls: 'js-dialog-close alert',
            onclick: function () {
              form.submit()
            }
          },
          {
            caption: this.$options.filters.trans('javascript.horse_registration.no'),
            cls: 'js-dialog-close'
          }
        ]
      })
    }
  }
}
</script>
